import React, {useContext, useEffect, useState} from 'react';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import {Link, useParams} from "react-router-dom";
import {handleImageUrl, slugify} from "../helpers";
import 'react-datepicker/dist/react-datepicker.css';
import {axios} from "../axios";
import {LangContext} from "../App";
import {Typography} from "@mui/material";
import Seo from "../components/Seo/Seo";

const EmbassySingle = () => {
    const id = useParams().id
    const [data,setData] = useState()
    const lang = useContext(LangContext)
    const [feed,setFeed] = useState([])
    useEffect(()=>{
        axios.get(`${lang}/embassy`)
            .then(res => setFeed(res.data.tours))
            .catch(() => setFeed([]))
    },[lang])
    useEffect(()=>{
        axios.get(`${lang}/embassy/${id}`)
            .then(res => setData(res.data))
            .catch(() => setData(null))
    },[id,lang])
    return (
        <div className='tour-page'>
            <Seo
                pageKey="embassies"
                title={data?.title}
                description={data?.description?.replace(/<[^>]*>?/gm, '').substring(0, 160)}
            />
            <div className="center-wrapper">
                <main>
                    <div className="row w-100">
                        <div className="col-9">
                            <div className="tour-info">
                                <div className="tour-image">
                                    <img src={handleImageUrl(data?.thumbnail)} alt={data?.title}
                                         className='embassy-image'/>
                                </div>
                                <h1 className="tour-title">{data?.title}</h1>
                                <div className="main-text" dangerouslySetInnerHTML={{__html: data?.text}}></div>
                                <div className='w-100 d-flex flex-column align-content-center embassy-details'>
                                    {data?.address &&
                                        <p className='text-center'><b>Address: </b><span>{data?.address}</span></p>}
                                    {data?.code &&
                                        <p className='text-center'><b>Postal Code: </b><span>{data?.code}</span></p>}
                                    {data?.tel && <p className='text-center'><b>Tel: </b><span>{data?.tel}</span></p>}
                                    {data?.fax && <p className='text-center'><b>Fax: </b><span>{data?.fax}</span></p>}
                                    {data?.email &&
                                        <p className='text-center'><b>Email: </b><span>{data?.email}</span></p>}
                                    {data?.website && <p className='text-center'>
                                        <b>Website: </b>
                                        <span>
                                             <a href={data?.website} target="_blank" rel="noopener noreferrer">
                                                {data?.website}
                                             </a>
                                        </span>
                                    </p>}
                                    {data?.days &&
                                        <p className='text-center'><b>Working Days : </b><span>{data?.days}</span></p>}
                                    {data?.days &&
                                        <p className='text-center'><b>Working Hours: </b><span>{data?.visa}</span></p>}
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="right-bar">
                                <Typography fontSize={30} mb={3}>{lang === 'de' ? 'Weitere Botschaften' : 'Other embassies'}</Typography>
                                {feed?.filter((e) => String(e.id) !== String(id)).slice(0,4).map((e) => {
                                    const src = handleImageUrl(e.thumbnail)
                                    return (
                                        <Link key={e.id} to={`/${lang}/embassy-page/${e.id}/${slugify(e.title || '')}`} className="card">
                                            {src && <img src={src} alt=""/>}
                                            <h3 className='title'>{e.title}</h3>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default EmbassySingle;